// =========================================================
// * Product Page: https://abriron.com
//
// * Coded by Creative Ryan Morvaridi
// =========================================================
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import columnResize from './plugins/columnResize/columnResize'
import columnPin from './plugins/columnPin/columnPin'
import columnDrag from './plugins/columnDrag/columnDrag'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueObserveVisibility from 'vue-observe-visibility'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMobileDetection from 'vue-mobile-detection'
import excel from './views/dashboard/components/general/vue-excel-export'
import VueHtmlToPaper from 'vue-html-to-paper'
import VuetifyMoney from 'vuetify-money'
import ProductDialog from './views/dashboard/components/general/productDialog/index'
import moment from 'jalali-moment'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import HighchartsVue from 'highcharts-vue'
import VueClipboard from 'vue-clipboard2'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import browserDetect from 'vue-browser-detect-plugin'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import './registerServiceWorker'
import Mixin from './Mixins/mixin'
import VueColumnsResizableVuetify from 'vue-columns-resizable-vuetify'
import VueApexCharts from 'vue-apexcharts'

import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import AgGridRenderList from '@/views/dashboard/components/general/AgGridRenderList/index.vue'

import QRCode from 'qrcodejs2'
window.QRCode = QRCode

Vue.use(browserDetect)
Vue.use(moment)
Vue.use(VuetifyMoney)
Vue.config.productionTip = false
Vue.use(VueObserveVisibility)
// Vue.use(require('vue-shortkey'))
Vue.use(require('vue-shortkey'), { prevent: ['input', 'textarea'] })
Vue.use(VueMobileDetection)
Vue.use(excel)
Vue.use(HighchartsVue)
Vue.use(VueClipboard)
Vue.use(ProductDialog)

Vue.component('apexchart', VueApexCharts)
Vue.component('AgGridVue', AgGridVue)
Vue.component('AgGridRenderList', AgGridRenderList)

Vue.use(VueTelInputVuetify, {
  vuetify
})
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})
Vue.use(VueColumnsResizableVuetify)
Vue.use(columnResize)
Vue.use(columnPin)
Vue.use(columnDrag)
/* Establish Connection */
// const socketConnection = SocketIO('https://live.abriron.com:3000')
// const socketConnection = SocketIO('https://127.0.0.1:4022/chat')
//
// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: socketConnection
// })
// )
Vue.mixin(Mixin)
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    // 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet',
    // 'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css',
    // 'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
  ]
})

var token = localStorage.getItem('token')
var appKey = localStorage.getItem('APP_KEY')

if (token != null && token != undefined) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + JSON.parse(token).token
} else {
  router.push('/login')
}
if (appKey) {
  // axios.defaults.headers.common.domain = appKey
}

Vue.prototype.$moment = moment
Vue.prototype.$axios = axios
var hostName = ''
var brand = ''

if (location.host === 'abr.abriron.com') {
  brand = 'abriron'
  hostName = 'https://src.abriron.com'
} else {
  var mainHostName = window.location.hostname
  var host = mainHostName.split('.')
  if (host.length > 1) {
    host = host[host.length - 2]
  } else {
    host = mainHostName
  }
  if (host === 'localhost') {
    brand = 'abriron'
  } else {
    brand = host
  }
  hostName = 'https://src.abriron.com'
  if (host === 'localhost' || location.host === 'abr.abriron.net' || location.hostname === '192.168.100.106') {
    hostName = 'https://src.abriron.net'
    // hostName = 'https://src.abriron.com'
  }
}

Vue.prototype.$HostName = location.origin
Vue.prototype.$brand = brand
Vue.prototype.$endpoint = hostName + '/api/v1/'
Vue.prototype.$apipoint = hostName + '/api/'
Vue.prototype.$endpointI = hostName + '/api/v2/'
Vue.prototype.$baseURL = window.location.origin
Vue.use(VueAxios, axios)
// Vue.prototype.$numberFormat = function (x, type = 'currency', currencyDecimal = 10) {
//   if (isNaN(x)) {
//     return 0
//   }
//   if (x === null || x === undefined) {
//     return 0
//   }
//   x = parseFloat(x)
//   var decimal = 0
//   if (Math.floor(x.valueOf()) === x.valueOf()) {
//     decimal = 0
//   } else {
//     decimal = x.toString().split('.')[1].length || 0
//   }
//   if (type === 'currency' && store && store.state && store.state.currency) {
//     if (currencyDecimal !== 10) {
//       x = x.toFixed(currencyDecimal).replace(/\.0+$/, '')
//     } else {
//       decimal = (store.state.currency && store.state.currency.decimal !== null ? store.state.currency.decimal : 0)
//       x = x.toFixed((decimal < 4 ? decimal : 4)).replace(/\.0+$/, '')
//     }
//   }
//   return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
// }
// const originalWarn = console.warn

// بازنویسی متد console.warn

// Vue.config.devtools = false
// Vue.config.productionTip = false
Vue.component('date-picker', VuePersianDatetimePicker)
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
